import React from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import AVText from 'src/components/elements/AVText';
import Styles from 'src/components/Styles';
import {getDescriber as getScreenDescriptor} from 'src/components/screens/descriptor/DescriptorType';

interface RewardDetailsInfoProps {
  IconComponent: React.ComponentType<{color: string}>;
  title: string;
  description: string;
}

const RewardDetailsInfo = ({
  IconComponent,
  title,
  description,
}: RewardDetailsInfoProps) => {
  return (
    <View
      style={Platform.OS === 'web' ? styles.gridItemWeb : styles.gridItemMobile}
    >
      <IconComponent color={getScreenDescriptor().getOneTimePayEarnColor()} />
      <View style={styles.textContent}>
        <AVText style={styles.earnedPointsRate}>{title}</AVText>
        <AVText style={styles.rewardDetailsDesc}>{description}</AVText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  gridItemWeb: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: Styles.Spacing.m2 + Styles.Spacing.m3,
  },
  gridItemMobile: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingVertical: Styles.Spacing.m2 + Styles.Spacing.m3,
  },
  earnedPointsRate: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    lineHeight: Styles.Fonts.f1 * 1.14,
    paddingBottom: Styles.Spacing.m1 + 2,
    textAlign: Platform.OS === 'web' ? 'center' : 'left',
  },
  rewardDetailsDesc: {
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    lineHeight: Styles.Fonts.f1 * 1.14,
    textAlign: Platform.OS === 'web' ? 'center' : 'left',
  },
  textContent: {
    paddingTop: Styles.Spacing.m2,
    alignItems: Platform.OS === 'web' ? 'center' : 'flex-start',
  },
});

export default RewardDetailsInfo;
